'use strict'
const { ERROR } = require('dbsm-common/src/bi/biErrorCodes')
const isError_ = require('lodash/isError')
const has_ = require('lodash/has')
const get_ = require('lodash/get')
const getUrlFromEvent = require('dbsm-common/src/getUrlFromEvent')

function getExtraInfoFromBIError(biError) {
  return has_(biError, 'isTrusted')
    ? {
        biUrl: getUrlFromEvent(
          biError,
          'Failed to get BI url from the DOM event'
        )
      }
    : { biError }
}

function getBIErrorInfo(biPayload, biError) {
  if (isError_(biError)) {
    return {
      exception: biError,
      extra: { biPayload }
    }
  } else {
    return {
      exception: new Error('Failed to send error to BI'),
      extra: Object.assign({ biPayload }, getExtraInfoFromBIError(biError))
    }
  }
}

function reportBIError({ appLogger, biPayload, biError }) {
  const { exception, extra } = getBIErrorInfo(biPayload, biError)

  appLogger.error(exception, {
    ignoreBI: true,
    level: 'info',
    extra
  })
}

function safeLog({ biLogger, biPayload, appLogger }) {
  try {
    biLogger(biPayload).catch(biError =>
      reportBIError({ appLogger, biPayload, biError })
    )
  } catch (biError) {
    reportBIError({ appLogger, biPayload, biError })
  }
}

module.exports = (biLogger, appLogger, shouldSend = () => true) => {
  const shouldSendBI = data =>
    !data.ignoreBI &&
    (!data.level || data.level === 'error') &&
    shouldSend(get_(data, 'exception.values[0].type'))

  appLogger.onAppError(data => {
    if (shouldSendBI(data)) {
      if (data.exception) {
        const exception = data.exception.values[0]
        const biPayload = {
          dsc: exception.value,
          errn: exception.value,
          errc: ERROR
        }
        safeLog({ biLogger, biPayload, appLogger })
      } else {
        const biPayload = {
          errn: data.message,
          errc: ERROR
        }
        safeLog({ biLogger, biPayload, appLogger })
      }
    }
  })
}



// WEBPACK FOOTER //
// ./logger/sendBiOnError.js